const identityPolicyEn = {
  comingSoon: 'This setting is not available yet.',
  comingSoonBadge: 'Coming soon',
  passwordPolicy: {
    complexity: {
      lowercase: 'Lowercase letters',
      none: 'Not required',
      number: 'Numbers',
      symbol: 'Symbols',
      uppercase: 'Uppercase letters'
    },
    description: 'Controls password strength for DRESS CODE native sign-in with reference to NIST SP 800-63B-4.',
    edit: {
      cancelButton: 'Cancel',
      complexity: {
        description: 'NIST recommends length over character-type rules. Turn these on only when your own policy requires them.',
        title: 'Character type complexity'
      },
      description: 'These settings apply to DRESS CODE native sign-in only.',
      discardConfirm: 'Discard',
      discardDescription: 'You have unsaved changes. Leaving this page discards them.',
      discardTitle: 'Discard changes?',
      enforceFrom: {
        description: 'Choose whether to apply the policy immediately or schedule it for a future date.',
        immediateDescription: 'Make the policy effective as soon as it is saved.',
        immediateTitle: 'Apply immediately',
        placeholder: 'Apply immediately',
        requiredHint: 'Select an effective date.',
        scheduledDescription: 'Choose a future date for the policy to take effect.',
        scheduledTitle: 'Schedule',
        title: 'Effective date'
      },
      leakedCheck: {
        description: 'Rejects passwords found in known breach lists. Recommended by NIST.',
        title: 'Breach list check'
      },
      minLength: {
        description: 'DRESS CODE recommends at least {{minLength}} characters.',
        hint: 'Enter a value between {{min}} and {{max}} characters.',
        title: 'Minimum length'
      },
      notConfiguredNotice: 'This organization has no custom policy yet, so the DRESS CODE standard settings are in effect. Saving makes them explicit.',
      notConfiguredTitle: 'No custom organization policy is configured',
      saveButton: 'Save',
      title: 'Edit password policy'
    },
    editButton: 'Edit',
    history: {
      button: 'History',
      close: 'Close history',
      collapse: 'Exit full screen',
      columns: {
        complexity: 'Character complexity',
        createdAt: 'Created',
        enforceFrom: 'Effective from',
        leakedCheck: 'Breach list check',
        minLength: 'Minimum length',
        status: 'Status'
      },
      complexity: {
        lowercase: 'Lowercase',
        none: 'None',
        number: 'Number',
        symbol: 'Symbol',
        uppercase: 'Uppercase'
      },
      description: 'Review the current, scheduled, and previous password policy versions.',
      expand: 'View full screen',
      leakedCheckOff: 'OFF',
      leakedCheckOn: 'ON',
      loadError: 'Failed to load password policy history.',
      minLengthValue: '{{value}} characters',
      status: {
        active: 'Active',
        scheduled: 'Scheduled',
        superseded: 'Previous'
      },
      title: 'Password policy history'
    },
    loadError: 'Failed to load the password policy.',
    recommended: {
      applyButton: 'Apply recommended values',
      confirmDescription: 'DRESS CODE recommends at least {{minLength}} characters, all four character types, and the breached password check enabled. You can still save a weaker policy.',
      confirmTitle: 'Save a policy below the recommended level?',
      warning: 'This policy is below the DRESS CODE recommendation ({{minLength}}+ characters, all character types, breached password check enabled).'
    },
    retry: 'Retry',
    rows: {
      complexity: 'Character type complexity',
      leakedCheck: 'Breach list check',
      leakedCheckHint: 'Rejects known breached or weak passwords.',
      leakedCheckOff: 'OFF',
      leakedCheckOn: 'ON',
      minLength: 'Minimum length',
      minLengthValue: '{{value}} characters'
    },
    standardBadge: 'References NIST SP 800-63B-4',
    title: 'Password policy',
    toast: {
      updateSuccess: 'Password policy updated'
    },
    versions: {
      current: 'Currently effective',
      defaultBadge: 'Standard settings',
      enforceFromCurrent: 'Effective since {{date}}',
      enforceFromScheduled: 'Effective from {{date}}',
      enforceImmediate: 'Applied immediately',
      scheduled: 'Scheduled',
      updatedAt: 'Updated: {{date}}'
    }
  }
};
export default identityPolicyEn;